import type { LabeledValuePayload } from '@Application/Ai/AiConfiguration/Assignments/Actions/modelAssignmentsFetched';

/** `effectiveLevel.value` is `'account' | 'organization' | 'facility'`: gendered phrasing cannot be
 * derived from `effectiveLevel.label` ("Compte" / "Structure" / "Agence") without sounding wrong. */
const INHERITED_FROM_PHRASES: Record<string, string> = {
	account: 'Hérité du compte.',
	organization: 'Hérité de la structure.',
	facility: "Hérité de l'agence.",
};

/** `null` means nobody has decided at any level — distinct from an inherited empty override. */
const inheritedFromPhrase = (effectiveLevel: LabeledValuePayload | null): string | null => {
	if (effectiveLevel === null) {
		return null;
	}

	return INHERITED_FROM_PHRASES[effectiveLevel.value] ?? `Hérité de ${effectiveLevel.label}.`;
};

export default inheritedFromPhrase;
